export const EVENTS_VOLUME_PP = 'events_volume_pp';
export const EVENT_ATTENDEES_PP = 'event_attendees_pp';
export const EVENT_CATEGORY = 'event_category';
export const EVENT_VERTICAL = 'event_vertical';

export const SALES_OPTIONS_NAMES = {
    SALES_JUST_ONE: 'just_one_event',
    SALES_2_TO_5: '2-5_events',
    SALES_5_TO_10: '5-10_events',
    SALES_10_TO_25: '10-25_events',
    SALES_MORE_THAN_25: 'More_than_25_events',
    SALES_UNKNOWN: 'i_am_not_sure_yet',
};

export const VISITORS_OPTIONS_NAMES = {
    VISITORS_25: 'up_to_25_people',
    VISITORS_100: 'up_to_100_people',
    VISITORS_250: 'up_to_250_people',
    VISITORS_UNLIMITED: 'more_than_250_people',
    VISITORS_UNKNOWN: 'i_am_not_sure_yet',
};

export const CREATOR_CATEGORY_NAMES = {
    COMEDY: 'comedy',
    FOOD_AND_DRINK: 'food_and_drink',
    MUSIC: 'music',
    COMMUNITY_AND_CULTURE: 'community_and_culture',
    HOBBIES_AND_SPECIAL_INTEREST: 'hobbies_and_special_interest',
    PERFORMING_AND_VISUAL_ARTS: 'performing_and_visual_arts',
    PARTIES: 'parties',
    FASHION_AND_BEAUTY: 'fashion_and_beauty',
    BUSINESS_AND_PROFESSIONAL: 'business_and_professional',
    NON_PROFIT: 'non-profit',
    RELIGION_AND_SPIRITUALITY: 'religion_and_spirituality',
    FAMILY_AND_EDUCATION: 'family_and_education',
    HEALTH_AND_WELLNESS: 'health_and_wellness',
    EVENTS_COMPANY_AGENCY_OR_PROMOTER: 'events_company_agency_or_promoter',
    SPORTS_AND_FITNESS: 'sports_and_fitness',
    OTHER: 'other',
};

export const MUSIC_CREATOR_CATEGORY_NAMES = {
    MUSIC_PROMOTER: 'music_promoter',
    MUSIC_NIGHTLIFE_AND_PARTIES: 'music_nightlife_and_parties',
    MUSIC_ARTIST_OR_PERFORMER: 'music_artist_or_performer',
    MUSIC_VENUE: 'music_venue',
    MUSIC_FESTIVAL: 'music_festival',
};

export const SALES_OPTIONS_VALUES = {
    SALES_JUST_ONE: 88,
    SALES_2_TO_5: 89,
    SALES_5_TO_10: 90,
    SALES_10_TO_25: 91,
    SALES_MORE_THAN_25: 92,
    SALES_UNKNOWN: 93,
};

export const VISITORS_OPTIONS_VALUES = {
    VISITORS_25: 94,
    VISITORS_100: 95,
    VISITORS_250: 96,
    VISITORS_UNLIMITED: 97,
    VISITORS_UNKNOWN: 98,
};

export const CREATOR_CATEGORY_VALUES = {
    COMEDY: 99,
    FOOD_AND_DRINK: 100,
    MUSIC: 101,
    COMMUNITY_AND_CULTURE: 102,
    HOBBIES_AND_SPECIAL_INTEREST: 103,
    PERFORMING_AND_VISUAL_ARTS: 104,
    PARTIES: 105,
    FASHION_AND_BEAUTY: 106,
    BUSINESS_AND_PROFESSIONAL: 107,
    NON_PROFIT: 108,
    RELIGION_AND_SPIRITUALITY: 109,
    FAMILY_AND_EDUCATION: 110,
    HEALTH_AND_WELLNESS: 111,
    EVENTS_COMPANY_AGENCY_OR_PROMOTER: 112,
    SPORTS_AND_FITNESS: 113,
    OTHER: 114,
};

export const MUSIC_CREATOR_CATEGORY_VALUES = {
    MUSIC_PROMOTER: 115,
    MUSIC_NIGHTLIFE_AND_PARTIES: 116,
    MUSIC_ARTIST_OR_PERFORMER: 117,
    MUSIC_VENUE: 118,
    MUSIC_FESTIVAL: 119,
};

export const SALES_OPTIONS_HEAP_NAMES: { [key: string]: string } = {
    just_one_event: 'Just one event',
    '2-5_events': '2-5 events',
    '5-10_events': '5-10 events',
    '10-25_events': '10-25 events',
    More_than_25_events: 'More than 25 events',
    i_am_not_sure_yet: "I'm not sure yet",
};

export const VISITORS_OPTIONS_HEAP_NAMES: { [key: string]: string } = {
    up_to_25_people: 'Up to 25 people',
    up_to_100_people: 'Up to 100 people',
    up_to_250_people: 'Up to 250 people',
    more_than_250_people: 'More than 250 people',
    i_am_not_sure_yet: "I'm not sure yet",
};

export const CREATOR_CATEGORY_HEAP_NAMES: { [key: string]: string } = {
    COMEDY: 'Comedy',
    FOOD_AND_DRINK: 'Food & Drink',
    MUSIC: 'Music',
    COMMUNITY_AND_CULTURE: 'Community & Culture',
    HOBBIES_AND_SPECIAL_INTEREST: 'Hobbies & Special Interest',
    PERFORMING_AND_VISUAL_ARTS: 'Performing & Visual Arts',
    PARTIES: 'Parties',
    FASHION_AND_BEAUTY: 'Fashion & Beauty',
    BUSINESS_AND_PROFESSIONAL: 'Business & Professional',
    NON_PROFIT: 'Non-Profit',
    RELIGION_AND_SPIRITUALITY: 'Religion & Spirituality',
    FAMILY_AND_EDUCATION: 'Family & Education',
    HEALTH_AND_WELLNESS: 'Health & Wellness',
    EVENTS_COMPANY_AGENCY_OR_PROMOTER: 'Events Company, Agency, or Promoter',
    SPORTS_AND_FITNESS: 'Sports & Fitness',
    OTHER: 'Other',
};

export const MUSIC_CREATOR_CATEGORY_HEAP_NAMES: { [key: string]: string } = {
    MUSIC_PROMOTER: 'Music Promoter',
    MUSIC_NIGHTLIFE_AND_PARTIES: 'Music Nightlife & Parties',
    MUSIC_ARTIST_OR_PERFORMER: 'Music Artist or Performer',
    MUSIC_VENUE: 'Music Venue',
    MUSIC_FESTIVAL: 'Music Festival',
};

export const QUESTION_OPTIONS = {
    SALES: [
        {
            value: SALES_OPTIONS_VALUES['SALES_JUST_ONE'],
            name: SALES_OPTIONS_NAMES['SALES_JUST_ONE'],
            heapName: SALES_OPTIONS_HEAP_NAMES['just_one_event'],
        },
        {
            value: SALES_OPTIONS_VALUES['SALES_2_TO_5'],
            name: SALES_OPTIONS_NAMES['SALES_2_TO_5'],
            heapName: SALES_OPTIONS_HEAP_NAMES['2-5_events'],
        },
        {
            value: SALES_OPTIONS_VALUES['SALES_5_TO_10'],
            name: SALES_OPTIONS_NAMES['SALES_5_TO_10'],
            heapName: SALES_OPTIONS_HEAP_NAMES['5-10_events'],
        },
        {
            value: SALES_OPTIONS_VALUES['SALES_10_TO_25'],
            name: SALES_OPTIONS_NAMES['SALES_10_TO_25'],
            heapName: SALES_OPTIONS_HEAP_NAMES['10-25_events'],
        },
        {
            value: SALES_OPTIONS_VALUES['SALES_MORE_THAN_25'],
            name: SALES_OPTIONS_NAMES['SALES_MORE_THAN_25'],
            heapName: SALES_OPTIONS_HEAP_NAMES['More_than_25_events'],
        },
        {
            value: SALES_OPTIONS_VALUES['SALES_UNKNOWN'],
            name: SALES_OPTIONS_NAMES['SALES_UNKNOWN'],
            heapName: SALES_OPTIONS_HEAP_NAMES['i_am_not_sure_yet'],
        },
    ],
    VISITORS: [
        {
            value: VISITORS_OPTIONS_VALUES['VISITORS_25'],
            name: VISITORS_OPTIONS_NAMES['VISITORS_25'],
            heapName: VISITORS_OPTIONS_HEAP_NAMES['up_to_25_people'],
        },
        {
            value: VISITORS_OPTIONS_VALUES['VISITORS_100'],
            name: VISITORS_OPTIONS_NAMES['VISITORS_100'],
            heapName: VISITORS_OPTIONS_HEAP_NAMES['up_to_100_people'],
        },
        {
            value: VISITORS_OPTIONS_VALUES['VISITORS_250'],
            name: VISITORS_OPTIONS_NAMES['VISITORS_250'],
            heapName: VISITORS_OPTIONS_HEAP_NAMES['up_to_250_people'],
        },
        {
            value: VISITORS_OPTIONS_VALUES['VISITORS_UNLIMITED'],
            name: VISITORS_OPTIONS_NAMES['VISITORS_UNLIMITED'],
            heapName: VISITORS_OPTIONS_HEAP_NAMES['more_than_250_people'],
        },
        {
            value: VISITORS_OPTIONS_VALUES['VISITORS_UNKNOWN'],
            name: VISITORS_OPTIONS_NAMES['VISITORS_UNKNOWN'],
            heapName: VISITORS_OPTIONS_HEAP_NAMES['i_am_not_sure_yet'],
        },
    ],
    CATEGORY: [
        {
            value: CREATOR_CATEGORY_VALUES['COMEDY'],
            name: CREATOR_CATEGORY_NAMES['COMEDY'],
            heapName: CREATOR_CATEGORY_HEAP_NAMES['COMEDY'],
        },
        {
            value: CREATOR_CATEGORY_VALUES['FOOD_AND_DRINK'],
            name: CREATOR_CATEGORY_NAMES['FOOD_AND_DRINK'],
            heapName: CREATOR_CATEGORY_HEAP_NAMES['FOOD_AND_DRINK'],
        },
        {
            value: CREATOR_CATEGORY_VALUES['MUSIC'],
            name: CREATOR_CATEGORY_NAMES['MUSIC'],
            heapName: CREATOR_CATEGORY_HEAP_NAMES['MUSIC'],
        },
        {
            value: CREATOR_CATEGORY_VALUES['COMMUNITY_AND_CULTURE'],
            name: CREATOR_CATEGORY_NAMES['COMMUNITY_AND_CULTURE'],
            heapName: CREATOR_CATEGORY_HEAP_NAMES['COMMUNITY_AND_CULTURE'],
        },
        {
            value: CREATOR_CATEGORY_VALUES['HOBBIES_AND_SPECIAL_INTEREST'],
            name: CREATOR_CATEGORY_NAMES['HOBBIES_AND_SPECIAL_INTEREST'],
            heapName:
                CREATOR_CATEGORY_HEAP_NAMES['HOBBIES_AND_SPECIAL_INTEREST'],
        },
        {
            value: CREATOR_CATEGORY_VALUES['PERFORMING_AND_VISUAL_ARTS'],
            name: CREATOR_CATEGORY_NAMES['PERFORMING_AND_VISUAL_ARTS'],
            heapName: CREATOR_CATEGORY_HEAP_NAMES['PERFORMING_AND_VISUAL_ARTS'],
        },
        {
            value: CREATOR_CATEGORY_VALUES['PARTIES'],
            name: CREATOR_CATEGORY_NAMES['PARTIES'],
            heapName: CREATOR_CATEGORY_HEAP_NAMES['PARTIES'],
        },
        {
            value: CREATOR_CATEGORY_VALUES['FASHION_AND_BEAUTY'],
            name: CREATOR_CATEGORY_NAMES['FASHION_AND_BEAUTY'],
            heapName: CREATOR_CATEGORY_HEAP_NAMES['FASHION_AND_BEAUTY'],
        },
        {
            value: CREATOR_CATEGORY_VALUES['BUSINESS_AND_PROFESSIONAL'],
            name: CREATOR_CATEGORY_NAMES['BUSINESS_AND_PROFESSIONAL'],
            heapName: CREATOR_CATEGORY_HEAP_NAMES['BUSINESS_AND_PROFESSIONAL'],
        },
        {
            value: CREATOR_CATEGORY_VALUES['NON_PROFIT'],
            name: CREATOR_CATEGORY_NAMES['NON_PROFIT'],
            heapName: CREATOR_CATEGORY_HEAP_NAMES['NON_PROFIT'],
        },
        {
            value: CREATOR_CATEGORY_VALUES['RELIGION_AND_SPIRITUALITY'],
            name: CREATOR_CATEGORY_NAMES['RELIGION_AND_SPIRITUALITY'],
            heapName: CREATOR_CATEGORY_HEAP_NAMES['RELIGION_AND_SPIRITUALITY'],
        },
        {
            value: CREATOR_CATEGORY_VALUES['FAMILY_AND_EDUCATION'],
            name: CREATOR_CATEGORY_NAMES['FAMILY_AND_EDUCATION'],
            heapName: CREATOR_CATEGORY_HEAP_NAMES['FAMILY_AND_EDUCATION'],
        },
        {
            value: CREATOR_CATEGORY_VALUES['HEALTH_AND_WELLNESS'],
            name: CREATOR_CATEGORY_NAMES['HEALTH_AND_WELLNESS'],
            heapName: CREATOR_CATEGORY_HEAP_NAMES['HEALTH_AND_WELLNESS'],
        },
        {
            value: CREATOR_CATEGORY_VALUES['EVENTS_COMPANY_AGENCY_OR_PROMOTER'],
            name: CREATOR_CATEGORY_NAMES['EVENTS_COMPANY_AGENCY_OR_PROMOTER'],
            heapName:
                CREATOR_CATEGORY_HEAP_NAMES[
                    'EVENTS_COMPANY_AGENCY_OR_PROMOTER'
                ],
        },
        {
            value: CREATOR_CATEGORY_VALUES['SPORTS_AND_FITNESS'],
            name: CREATOR_CATEGORY_NAMES['SPORTS_AND_FITNESS'],
            heapName: CREATOR_CATEGORY_HEAP_NAMES['SPORTS_AND_FITNESS'],
        },
        {
            value: CREATOR_CATEGORY_VALUES['OTHER'],
            name: CREATOR_CATEGORY_NAMES['OTHER'],
            heapName: CREATOR_CATEGORY_HEAP_NAMES['OTHER'],
        },
    ],
    VERTICAL: [
        {
            value: MUSIC_CREATOR_CATEGORY_VALUES['MUSIC_PROMOTER'],
            name: MUSIC_CREATOR_CATEGORY_NAMES['MUSIC_PROMOTER'],
            heapName: MUSIC_CREATOR_CATEGORY_HEAP_NAMES['MUSIC_PROMOTER'],
        },
        {
            value: MUSIC_CREATOR_CATEGORY_VALUES['MUSIC_NIGHTLIFE_AND_PARTIES'],
            name: MUSIC_CREATOR_CATEGORY_NAMES['MUSIC_NIGHTLIFE_AND_PARTIES'],
            heapName:
                MUSIC_CREATOR_CATEGORY_HEAP_NAMES[
                    'MUSIC_NIGHTLIFE_AND_PARTIES'
                ],
        },
        {
            value: MUSIC_CREATOR_CATEGORY_VALUES['MUSIC_ARTIST_OR_PERFORMER'],
            name: MUSIC_CREATOR_CATEGORY_NAMES['MUSIC_ARTIST_OR_PERFORMER'],
            heapName:
                MUSIC_CREATOR_CATEGORY_HEAP_NAMES['MUSIC_ARTIST_OR_PERFORMER'],
        },
        {
            value: MUSIC_CREATOR_CATEGORY_VALUES['MUSIC_VENUE'],
            name: MUSIC_CREATOR_CATEGORY_NAMES['MUSIC_VENUE'],
            heapName: MUSIC_CREATOR_CATEGORY_HEAP_NAMES['MUSIC_VENUE'],
        },
        {
            value: MUSIC_CREATOR_CATEGORY_VALUES['MUSIC_FESTIVAL'],
            name: MUSIC_CREATOR_CATEGORY_NAMES['MUSIC_FESTIVAL'],
            heapName: MUSIC_CREATOR_CATEGORY_HEAP_NAMES['MUSIC_FESTIVAL'],
        },
    ],
};
